/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const ionisingRadiationQuestions = [
    {
        id: questionIds.TreatmentSinceLastOhMedicalExamination,
        questionText: "Have you, since your last medical examination at Occupational Health, been treated by your family doctor or a specialist?",
    },
    {
        id: questionIds.TreatmentSinceLastOhMedicalExaminationFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AbsentLast12MonthsThroughIllness,
        questionText: "Have you been absent from work through illness in the past 12 months?",
    },
    {
        id: questionIds.AbsentLast12MonthsThroughIllnessFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.RashesInLast12Months,
        questionText: "In the last 12 months have you experienced Rashes or other skin problems?",
    },
    {
        id: questionIds.RashesInLast12MonthsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AnyOverCounterMedicationMoreThanOnce,
        questionText: "Have you had to use any “over the counter” medication (including creams) more than once in the last year?",
    },
    {
        id: questionIds.AnyOverCounterMedicationMoreThanOnceFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.UseRespiratoryProtectiveEquipment,
        questionText: "Do you use respiratory protective equipment (apart from in emergencies)?",
    },
    {
        id: questionIds.UseRespiratoryProtectiveEquipmentFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.IncurredHigherRadiationDose,
        questionText: "Have you been involved in any incident which you incurred a higher radiation dose than usual or were contaminated?",
    },
    {
        id: questionIds.IncurredHigherRadiationDoseFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.WorkWithRatiationChangedLast12Months,
        questionText: "Has the nature of your work with radiation or sources of radiation changed in the last 12 months?",
    },
    {
        id: questionIds.WorkWithRatiationChangedLast12MonthsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ExposureCarcinogenicAgents,
        questionText: "Have you ever been exposed to any other carcinogenic agents at work?",
    },
    {
        id: questionIds.ExposureCarcinogenicAgentsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadSpecialXRaysScansRadioTherapy,
        questionText: "Have you ever had any special x-rays, scans (not MRI or ultrasound) or radiotherapy?",
    },
    {
        id: questionIds.EverHadSpecialXRaysScansRadioTherapyFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.FeelsTheNeedForMedicalExamination,
        questionText: "With regards to your present state of health, do you feel you need to have a medical examination or see an Appointed Doctor?",
    },
    {
        id: questionIds.FeelsTheNeedForMedicalExaminationFurtherDetails,
        questionText: "Please provide details",
    }
];
